import { t } from '@lingui/core/macro'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { FaPills } from 'react-icons/fa6'
import { ArticleSchema } from './schema/Article'

export const ArticleConfig = defineEntityConfig(() => ({
  schema: ArticleSchema,

  label: t`Artikel`,
  labelPlural: t`Artikel`,

  icon: FaPills,

  route: {
    list: '/artikel',
    edit: '/artikel/$id',
  },

  relationSelectionColumns: [
    {
      title: t`Name`,
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: t`PZN`,
      key: 'pzn',
      render: (_, record) => record.pzn,
    },
    {
      title: t`Status`,
      key: 'status',
      render: (_, record) => record.status,
    },
  ],

  search: {
    sortableFields: ['name', 'pzn', 'status', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
    secondary: val => val?.pzn,
  },
}))
